import { commonShortNouns } from "./common-short-fields";

export const examAdminCustomFieldDefinitions = {
  pageTitle: "自定义字段",
  pageSubtitle: "管理考生/考试/镜像字段定义及业务属性",
  archiveAction: "归档",
  createSuccess: "字段创建成功",
  updateSuccess: "字段更新成功",
  archiveSuccess: "字段已归档",
  confirmArchiveTitle: "确认归档这个字段？",
  targets: {
    candidate: "考生",
    exam: "考试",
    docker_image: "镜像",
  },
  objects: {
    field: "字段",
  },
  table: {
    target: "目标",
    fieldKey: "键",
    fieldLabel: "名称",
    dataType: "类型",
    visibility: "可见性",
    editability: "可编辑",
    requiredOnLogin: "登录必填",
    status: commonShortNouns.status,
    actions: "操作",
  },
  form: {
    target: "目标",
    fieldKey: "字段键",
    fieldLabel: "字段名称",
    dataType: "字段类型",
    requiredOnLogin: "登录必填（仅考生）",
    visibility: "可见性",
    editability: "可编辑性",
    optionsText: "选项（每行一个，select/multi_select 使用）",
    placeholder: "占位提示",
    helpText: "帮助说明",
    sortOrder: "排序",
    status: commonShortNouns.status,
    placeholders: {
      fieldKey: "例如：employee_no / emergency_contact",
      fieldLabel: "例如：工号 / 紧急联系人",
      optionsText: "例如：\n初级\n中级\n高级",
      placeholder: "例如：请输入工号",
      helpText: "例如：将用于登录后资料补全",
      sortOrder: "例如：10（数字越小越靠前）",
    },
  },
  labels: {
    active: "启用",
    archived: "已归档",
    visible: "可见",
    hidden: "隐藏",
    editable: "可编辑",
    readonly: "只读",
  },
};
